module.exports = __webpack_public_path__ + "static/media/searchicon.3bb70886.svg";